<div class="n-paragraph-fine-print fileUploadInstructions">
  <h2 class="fileUploadInstructions__label">
    {{'sfu_file_instruction_heading' | translate}}
  </h2>
  <div class="fileUploadInstructions__body">
    <span id="fileInstructionTxtOne" [innerHtml]="'sfu_file_instruction_text1' | translate | safeHtml">
    </span>
  </div>
</div>